import axios from 'axios';
import './axios-interceptor';

export default {
  async getAttachment(ref: string, id: string) {
    return await axios.get(`attachment/${ref}/${id}`);
  },
};
